import React, {  } from 'react';
import { useSelector } from 'react-redux';
import { getRregionalnoeOtdelenieFromRoles } from '../../../common/Tool';
import SeriiBlock from '../../components/SeriiBlock'
import PageLayout from '../../components/PageLayout';
import { GET, errorCatch, useAuth } from 'fennec-ui';
import { useLocaladminContext } from '../../../common/Context';

export default function LocaladminEventsSerii(props) {
    const local = useLocaladminContext();

    // const regionalnoeOtdelenie = useSelector(getRregionalnoeOtdelenieFromRoles(["АдминистраторОтделения", "АдминистраторМероприятийРО"], true));
    const auth = useAuth()
    // const [regionalnoeOtdelenie, setRegionalnoeOtdelenie] = React.useState([])
    // React.useEffect(()=>{
    //     GET(auth, '/api/ro/list-by-admin', ({data})=>{
    //         setRegionalnoeOtdelenie(data);
    //     }, errorCatch)
    // }, [])

    // const context = React.useMemo(() => ({
    //     collection: regionalnoeOtdelenie,
    //     title: "Региональное отделение",
    //     name: (item) => item.nazvanie,
    //     mix: (item) => {
    //         return {
    //             // organizatorFederatsiyaID: 1, // Организатор федерация
    //             // organizatorShkolaID: ID, // Организатор школа
    //             // organizatorMeropriyatiyaID: ID, // Организатор мероприятия
    //             organizatorRegionalnoeOtdelenieID: item?.ID // Организатор региональное отделение
    //         }
    //     }
    // }), [regionalnoeOtdelenie])

    return (<PageLayout>
        {local && <SeriiBlock auth={props.auth} source={"/api/serii/list/reg"}
            base="local-admin" 
            sourceKey="reg"
            create={true}
            // context={context}
            ctx={{organizatorRegionalnoeOtdelenieID: local?.ID}}
        />}
        </PageLayout>
    );
}
